import { Locale } from 'modules/i18n';

export const bannerTranslation = {
  [Locale.en]: {
    text: 'Effective August 1, 2025, access to Solana’s Bigtable-related archival data will no longer be available through our platform.',
  },
};
